export const BACKOFFICE_REDESIGN_ATTRIBUTE = 'data-backoffice-redesign';
export const BACKOFFICE_REDESIGN_ENABLED = '1';

const isBackofficeRedesignEnabled = () => (
    document.documentElement.getAttribute(BACKOFFICE_REDESIGN_ATTRIBUTE) === BACKOFFICE_REDESIGN_ENABLED
);

export default isBackofficeRedesignEnabled;
